import { render, staticRenderFns } from "./sales_dashboard.vue?vue&type=template&id=43d4c1c6&scoped=true"
import script from "./sales_dashboard.vue?vue&type=script&lang=js"
export * from "./sales_dashboard.vue?vue&type=script&lang=js"
import style0 from "./sales_dashboard.vue?vue&type=style&index=0&id=43d4c1c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d4c1c6",
  null
  
)

export default component.exports